import { api } from "../../api";
import { VIDEO_ENDPOINTS } from "../../../constants/endpoints";

export const videoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllVideos: builder.query({
      query: ({ page = 1, pageSize = 10, title = "" } = {}) => ({
        url: VIDEO_ENDPOINTS.GET_ALL,
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ page, pageSize, title }).toString(),
      }),
      providesTags: ["Video"],
    }),
    createVideo: builder.mutation({
      query: (videoData) => ({
        url: VIDEO_ENDPOINTS.CREATE,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: videoData,
      }),
      invalidatesTags: ["Video"],
    }),
    updateVideo: builder.mutation({
      query: (video) => ({
        url: VIDEO_ENDPOINTS.UPDATE,
        method: "POST",
        body: video,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Video"],
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: VIDEO_ENDPOINTS.DELETE,
        method: "POST",
        body: { id },
      }),
      invalidatesTags: ["Video"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllVideosQuery,
  useCreateVideoMutation,
  useUpdateVideoMutation,
  useDeleteVideoMutation,
} = videoApi;
